import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import Component from './Component';
import {buy} from "./Actions";
import {submitLogout} from "../Auth/Actions";
import {getCartTours} from "../Cart/Actions";

const stp = (s) => ({
  cities: s.main.cities,
  promiseLogout: s.auth.promise.logout,
  isAuthorized: s.auth.isAuthorized,
  userData: s.auth.user,
  list: s.cart.list || [],
  listOfTours: s.cart.toursList || [],
  metingPlace: s.cart.metingPlace,
});

const dtp = (d) => ({
  logout: () => {
    d(submitLogout())
  },
  getCartTours: () => {
    d(getCartTours())
  },
  buy: (data) => {
    d(buy(data))
  }
});

export default withRouter(connect(stp, dtp)(Component));


// WEBPACK FOOTER //
// ./src/app/containers/Booking/index.js